import { LandingPage } from '../LandingPage/LandingPage';

export const NotFound = () => {
  return <LandingPage />;
};
